import { Component, effect, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { distinctUntilChanged, Subscription } from 'rxjs';

import { ReportsViewEnum } from '../../models/enums/reports.enum';
import { ReportService } from '../../services/report.service';
import { ReportMapService } from '../../services/report-map.service';
import { GlobalContants } from '../../../common/constants/global.contants';
import { SharedService } from '../../../common/services/shared.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { layerConstant } from 'src/app/common/constants/layer-constant';
import { actionIdConstants } from 'src/app/common/constants/common.contants';
import { UserService } from 'src/app/common/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { activityPayload } from 'src/app/common/models/userActivity.model';

@Component({
  selector: 'app-report-map-legend',
  templateUrl: './report-map-legend.component.html',
  styleUrls: ['./report-map-legend.component.css']
})
export class ReportMapLegendComponent implements OnInit, OnDestroy {
  viewType = ReportsViewEnum;
  currentReportView: number = ReportsViewEnum.mapView;
  @ViewChild('mapZoomSlide') mapZoomSlide!: ElementRef;
  selectReportSub$: Subscription = new Subscription();
  reportViewSub$: Subscription = new Subscription();
  selectedReportSub$: Subscription = new Subscription();
  legendLayerSub$: Subscription = new Subscription();
  currentLegendView$: Subscription = new Subscription();
  isReport: boolean = false;
  location_Name: any = 'Neighborhood Name';
  layerselected: number = 1;
  legend_data: any;
  legend_data_by_group: any;
  current_lang: any = 'en';
  current_lang_id:any;
  public transaction_layer_active: boolean = true;
  public layerData: any = [];
  public legendData: any = [];
  limitedLegendData: any[] = [];
  public legend_data_by_groupData: any;
  public layer_year = new Date().getFullYear();
  showMarquee: boolean = false;
  showall_flag: boolean = false;
  is_transaction_report: boolean = false;
  limit:number=3;
  reportId: number = 0;

  constructor(public reportService: ReportService, private mapService: ReportMapService, private sharedService: SharedService,
    private translate: TranslateService, private userService: UserService,
    private activatedRoute: ActivatedRoute,
  ) {
    if (this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceName))
      this.location_Name = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceName).split('-')[0];
    this.sharedService.selectedCity$.subscribe((city: any) => {
      this.location_Name = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceName).split('-')[0];
    })
    effect(() => {

      const clusterData = this.reportService.clusterInfoData();
      const mapLayerData = this.reportService.mapLayerData();
       this.legend_data_by_group  = this.reportService.mapLayerDataCat();
        if(clusterData?.length > 0) {
        this.layerselected = this.legend_data_by_group?.length +1;
        } else {
          this.layerselected = this.legend_data_by_group?.length;
        }
        // console.log( " this.legend_data_by_group <<>>", this.legend_data_by_group)
      this.updateLimitedLegendData(this.limit);
    });


    this.sharedService.language$.subscribe((lang) => {
      this.current_lang_id = this.sharedService.getCurrentLangID();
      this.current_lang = lang;
      setTimeout(() => {
        this.playMarquee()
      },1);
    });
    // this.reportService.selectedReport$.subscribe((data) => {
      this.selectedReportSub$?.unsubscribe();
      this.selectedReportSub$ = this.reportService.selectedReport$.pipe(
        distinctUntilChanged()
      ).subscribe((data) => {
      this.transaction_layer_active = !data.flag;
      if (data.flag) {
        let layer_data = this.reportService.getCurrentReport();
        this.is_transaction_report = !!(layer_data?.filter_table == layerConstant.transaction_summary);
        this.limit = this.is_transaction_report? 2:3;
        if (layer_data) {
          this.layerData = layer_data.layer;
          // if (this.layerData) this.mapLegendmenu();
          this.legend_data_by_groupData = layer_data.legend;
          this.legendData = layer_data.legend;
         this.mapLegendmenu();
        }
      }
    })
  }

  ngOnInit(): void {
    this.mapService.mapZoom.subscribe((zoom: any) => { if (this.mapZoomSlide) this.mapZoomSlide.nativeElement.value = zoom });
    this.reportSet();
    this.reportView();
    this.reportId = this.activatedRoute.snapshot.queryParams['rid'];
    // this.mapService.transaction_LayerActive.subscribe((toggle: boolean) => {
    //   this.transaction_layer_active = toggle;
    // })
  }
  //Window Resize call marquee
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.playMarquee();
  }
  ngAfterViewInit() {
    this.playMarquee();
  }
  /**
   * Get marquee element & Check if content overflows
   */
  playMarquee(){
    let element = document.querySelector('.p-marquee') as HTMLElement;
    if(element) this.showMarquee = element.scrollWidth > element.clientWidth;
  }

  reportSet() {
    this.selectReportSub$ = this.reportService.selectedReport$.subscribe((isReport: any) => {
      this.isReport = isReport.flag;
      // this.currentReportView = this.isReport ? ReportsViewEnum.mapGridView : ReportsViewEnum.mapView;
      // this.reportService.reportView$.next(this.currentReportView);

    });
  }

  reportView() {
    this.reportViewSub$ = this.reportService.reportView$.subscribe(view => {
      this.currentReportView = view;
    })
  }

  changeView(view: ReportsViewEnum): void {
  try {

    // const isDetailPage = this.reportService.isDetailPageOpen;

    if (this.currentReportView === view) {
      return;
    }

    this.currentReportView = view;

    // if (isDetailPage) {
    //   if (view === ReportsViewEnum.gridView) {
    //     this.reportService.projectReportView = true;
    //   }
    //   else {
    //     this.reportService.projectReportView = false;
    //   }
    // } else {
    //   this.reportService.projectReportView = false;
    // }
    this.reportService.reportView$.next(view);

    const viewConfig = {
      [ReportsViewEnum.mapGridView]: {
        actionId: actionIdConstants.view_report_with_map,
        userData: 'Map & Report View'
      },
      [ReportsViewEnum.mapView]: {
        actionId: actionIdConstants.view_map_only,
        userData: 'Map View'
      },
      [ReportsViewEnum.gridView]: {
        actionId: actionIdConstants.view_report_only,
        userData: 'Report View'
      }
    };

    const activity: activityPayload = {
      userdata: { viewType: viewConfig[view].userData },
      actionId: viewConfig[view].actionId,
      entity: 'report',
      entityId: this.reportId
    };

    this.userService.logUserActivity(activity);

  } catch (error) {
    console.error(error);
  }
}



  mapZoomChanger(event: any) {
    let zoomval: any;
    this.mapService.mapZoom.subscribe((zoom: any) => { zoomval = zoom; });

    if (event.target?.value) zoomval = parseInt(event.target.value);
    else if (event == 'zoom-in') zoomval = parseInt(zoomval) + 1;
    else if (event == 'zoom-out') zoomval = parseInt(zoomval) - 1;

    this.mapService.setZoom(zoomval);
    this.mapZoomSlide.nativeElement.value = zoomval;
  }

  mapLegendmenu() {
    this.currentLegendView$?.unsubscribe();
    this.currentLegendView$ = this.mapService.legendLayerGroupList.pipe(
      distinctUntilChanged()
    ).subscribe((data: any) => {
      setTimeout(() => this.playMarquee());
      if(data){
        let legendData = this.mapService.filterLegendData(data);
        this.legend_data_by_group =  legendData.find((item:any)=> item.display == true && item.status == true);
        this.layerselected = this.legend_data_by_group ? 1: 0;
      } else {
        let lagendActiveGroupData = this.mapService.filterLegendData(this.legendData);
        this.legend_data_by_group = lagendActiveGroupData?.find((item:any)=> item.display == true && item.status == true);
        this.layerselected = this.legend_data_by_group ? 1: 0;
      }
    })
  }

  /**
 * Returns a limited number of legend data items from the legend_data_by_group.
 * This is useful for displaying a fixed number of legend entries in the UI,
 * such as the top 3.
 *
 * @param limit - The number of legend items to return.
 * @returns An array of legend data items, limited by the specified count.
 */
  updateLimitedLegendData(limit: number = 3) {
    if (this.legend_data_by_group) {
      if (Array.isArray(this.legend_data_by_group)) {
        this.limitedLegendData = (this.legend_data_by_group || [])
        .flat()
        .flatMap(item => item.data || [])
        .sort((a, b) => {
          const priority = [
            layerConstant.miprojects_labels[0].data[0].value,
            layerConstant.miprojects_labels[0].data[1].value,
          ];
          const aIndex = priority.indexOf(a.value);
          const bIndex = priority.indexOf(b.value);

          // Items in priority list come first, others remain after
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
          return 0;
        })
      } else {
        this.limitedLegendData = this.legend_data_by_group?.data;
      }
      this.showall_flag = !!(this.limitedLegendData.length > limit);
      this.limitedLegendData = this.limitedLegendData?.slice(0, limit) || [];
    } else {
      this.showall_flag = false;
      this.limitedLegendData = [];
    }
  }

  ngOnDestroy(): void {
    this.currentLegendView$?.unsubscribe();
    // this.selectedReportSub$?.unsubscribe();
    this.legendLayerSub$?.unsubscribe();
    this.selectedReportSub$?.unsubscribe();
    this.selectReportSub$?.unsubscribe();
  }

  legendExpand() {
    this.mapService.legendToggle.next(true);
  }

  returnVal(value: string, type: string, legend_obj?: any) {
    if (type == 'text') {
      return this.translate.instant(value.replace(/_/g, " ").toLowerCase());
    } else if (type == 'src') {
      let queryParam = this.reportService.queryParams;
      if (queryParam?.year) {
        this.layer_year = queryParam?.year.split(',').map(Number)
          .sort(function (a: any, b: any) { return a - b }).pop();
      } else if (!queryParam?.year) {
        this.layer_year = new Date().getFullYear();
      }
      let style_name;
      let place_id = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId);
      let store_name = this.layerData?.store_name;
      let layer_name = `${this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode)}_${this.layerData?.layer_name}_${this.layer_year}`;
      if (legend_obj.type != 'like') style_name = `style_Layer_${legend_obj.type}`;
      else style_name = `style_Layer_${legend_obj.legend}`;

      let url = `${environment.geoestater}wms-layer?place_id=${place_id}&token=${environment.user_token}&request=GetLegendGraphic&layer=${layer_name}` +
        `&style=${style_name}&width=20&height=20&store=${store_name}&rule=${value}`;
      return url;
    } else {
      return value;
    }
  }

  mapFullscreen() {
    this.mapService.mapFullscreenToggle.next(true);
  }

}
